import type { ColorValue, SolidStyle } from "~/lib/types";
import type { NodeDefinition } from "~/nodes/types";
import { DEFAULT_COLOR } from "~/nodes/definitions/colorPicker";

export const solidColorNode: NodeDefinition = {
  type: "solidColor",
  label: "Solid Color",
  category: "Style",
  inputs: [{ key: "color", label: "Color", socket: "color" }],
  outputs: [{ key: "style", label: "Style", socket: "style" }],
  controls: [],
  defaults: {},

  compute(ctx) {
    const { rgb } = ctx.connected<ColorValue>("color") ?? DEFAULT_COLOR;

    const style: SolidStyle = {
      type: "solid",
      color: { type: "RGB", r: rgb.r, g: rgb.g, b: rgb.b, a: 1 },
    };

    return { style };
  },
};
